define.alias("shared/components/shared/wizards/carousel/step-three", "calendar/components/shared/wizards/carousel/step-three");